import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Scale, Layers, Sparkles, ArrowLeft, ChevronDown, Menu, X, Shield } from 'lucide-react';

const CaseLawHeader = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => {
    if (path === '/case-laws' && location.pathname === '/case-laws') return true;
    if (path !== '/case-laws' && location.pathname.includes(path)) return true;
    return false;
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-slate-950/80 backdrop-blur-xl border-b border-cyan-500/20 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">

          {/* Left: Brand / Logo */}
          <div className="flex items-center gap-3">
            <Link to="/case-laws" className="flex items-center gap-3 group">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 p-0.5 shadow-lg shadow-cyan-500/20 group-hover:shadow-cyan-500/40 transition-all duration-300">
                <div className="w-full h-full bg-slate-950 rounded-[10px] flex items-center justify-center">
                  <Scale className="w-5 h-5 text-cyan-400 group-hover:scale-110 transition-transform" />
                </div>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-lg font-black tracking-tight text-white group-hover:text-cyan-300 transition-colors">
                    Tax Eases
                  </span>
                  <span className="text-[10px] font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-500/20 to-purple-500/20 text-cyan-400 border border-cyan-400/30 px-2 py-0.5 rounded-full">
                    Legal AI
                  </span>
                </div>
                <p className="text-[10px] text-slate-400 font-medium tracking-wide">
                  GST & Income Tax Intelligence
                </p>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex items-center gap-2">
            <Link
              to="/case-laws"
              className={`px-4 py-2 rounded-xl text-xs font-bold transition-all duration-200 flex items-center gap-2 ${
                location.pathname === '/case-laws'
                  ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-400/40 shadow-sm shadow-cyan-500/20'
                  : 'text-slate-300 hover:text-white hover:bg-white/5'
              }`}
            >
              <Sparkles className="w-3.5 h-3.5" />
              All Judgments
            </Link>

            <Link
              to="/case-laws/income-tax"
              className={`px-4 py-2 rounded-xl text-xs font-bold transition-all duration-200 flex items-center gap-2 ${
                location.pathname.includes('/income-tax')
                  ? 'bg-blue-500/20 text-blue-300 border border-blue-400/40 shadow-sm shadow-blue-500/20'
                  : 'text-slate-300 hover:text-white hover:bg-white/5'
              }`}
            >
              <Scale className="w-3.5 h-3.5 text-blue-400" />
              Income Tax
            </Link>

            <Link
              to="/case-laws/gst"
              className={`px-4 py-2 rounded-xl text-xs font-bold transition-all duration-200 flex items-center gap-2 ${
                location.pathname.includes('/gst')
                  ? 'bg-teal-500/20 text-teal-300 border border-teal-400/40 shadow-sm shadow-teal-500/20'
                  : 'text-slate-300 hover:text-white hover:bg-white/5'
              }`}
            >
              <Layers className="w-3.5 h-3.5 text-teal-400" />
              GST Rulings
            </Link>
          </nav>

          {/* Right Action: Return to Welcome Screen */}
          <div className="hidden md:flex items-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold text-slate-300 hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 transition-all"
            >
              <ArrowLeft className="w-3.5 h-3.5 text-slate-400" />
              Welcome Screen
            </Link>
          </div>

          {/* Mobile menu toggle */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-lg text-slate-300 hover:text-white hover:bg-white/10"
            >
              {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>

        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-slate-950/95 border-b border-cyan-500/20 px-4 pt-2 pb-4 space-y-1">
          <Link
            to="/case-laws"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3 py-2.5 rounded-lg text-sm font-semibold text-slate-200 hover:bg-cyan-500/20 hover:text-cyan-300"
          >
            All Judgments
          </Link>
          <Link
            to="/case-laws/income-tax"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3 py-2.5 rounded-lg text-sm font-semibold text-slate-200 hover:bg-cyan-500/20 hover:text-cyan-300"
          >
            Income Tax Judgments
          </Link>
          <Link
            to="/case-laws/gst"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3 py-2.5 rounded-lg text-sm font-semibold text-slate-200 hover:bg-cyan-500/20 hover:text-cyan-300"
          >
            GST Rulings & Orders
          </Link>
          <Link
            to="/"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3 py-2.5 rounded-lg text-sm font-semibold text-slate-400 hover:text-white"
          >
            ← Welcome Screen
          </Link>
        </div>
      )}
    </header>
  );
};

export default CaseLawHeader;
